const MAIL = {
  from: 'De :',
  envoyerA: 'Envoyer à :',
  cc: 'Cc :',
  cci: 'Cci :',
  objetMail: 'Objet :',
  message: 'Message :',
  ajoutezUnMessage: 'Ajoutez un message',
  collaborateur: 'COLLABORATEURS',
  error: {
    problemOccurred: 'Un problème est survenu',
    to: 'Le champs "Envoyer à" est obligatoire',
    objet: 'Le champs "Objet" est obligatoire',
    corps: 'Le champs "Message" est obligatoire',
    from: 'Le champs "De" est obligatoire',
    email: 'L\'email renseigné dans le champs "De" n\'est pas valide',
    uniqueEmail: 'Les emails des champs "Envoyer à :", "Cc :", "Cci :" et "De :" doivent être unique.',
  },
  success: {
    envoie: 'Le mail a bien été envoyé',
  },
  actions: {
    send: 'Envoyer',
    cancel: 'Annuler',
    pj: 'Ajouter une pièce jointe',
  },
};

export default MAIL;
